import React from 'react'

import { NavbarLink } from '../../hooks/useNavbarLinks/useNavbarLinks'

interface LinkSectionProps {
  title?: string
  links: NavbarLink[]
}

export const LinkSection: React.FC<LinkSectionProps> = ({ title, links }) => {
  if (!links.length) {
    return null
  }

  return (
    <>
      {title && (
        <p className="text-common-gray-7 text-xl font-normal desktop:text-2xl">
          {title}
        </p>
      )}
      <div className="gap-4 flex flex-col">{...links}</div>
    </>
  )
}
